import React from 'react';

import {StandingsWidgetLegendItem} from "./standings-widget.legend-item";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {StandingsDestinationViewModel} from "../../../../domain/standings/models/destinations/standings.destinations.view-model";
import classNames from "classnames";
import styles from "../../styles/standings-widget.module.scss";
import {StandingsWidgetController} from "../../standings-widget.controller";

class StandingsWidgetLegendContentProps extends BaseProps {
  controller: StandingsWidgetController;
  className: String;
}

export const StandingsWidgetLegendContent = ({controller, className}: StandingsWidgetLegendContentProps) => {
  const {state} = controller;
  const {shouldRenderLegendContent, destinations} = state;
  const {device} = state;

  return (
    shouldRenderLegendContent ? <div className={classNames(styles.legend_content, className, {[styles.legend_content_small_view]: device.isSmallView})}>
      {
        destinations?.map((row: StandingsDestinationViewModel, index: Number) => <StandingsWidgetLegendItem row={row} key={index}/>)
      }
    </div> : null
  )
}
